export default __webpack_public_path__ + "static/media/drew-testi.da005285.jpg";